module.exports = __webpack_public_path__ + "static/Elastic-ae99529a03a0cd0482fcb714e97d793f.jpg";